import * as tslib_1 from "tslib";
import { FormArray, FormGroup } from '@angular/forms';
export function addError(control, errorName) {
    var errors = control.errors || {};
    errors[errorName] = true;
    control.setErrors(errors);
}
export function removeError(control, errorName) {
    var errors = control.errors || {};
    delete errors[errorName];
    var hasMoreError = Object.keys(errors).length > 0;
    control.setErrors(hasMoreError ? errors : null);
}
export function getFormValidationErrors(form) {
    var result = [];
    Object.keys(form.controls).forEach(function (key) {
        var formProperty = form.get(key);
        if (formProperty instanceof FormGroup) {
            result.push.apply(result, tslib_1.__spread(getFormValidationErrors(formProperty)));
        }
        var controlErrors = formProperty.errors;
        if (controlErrors) {
            Object.keys(controlErrors).forEach(function (keyError) {
                result.push({
                    'control': key,
                    'error': keyError,
                    'value': controlErrors[keyError]
                });
            });
        }
    });
    return result;
}
export function logFromErrors(parentKeyName, parent) {
    if (parent instanceof FormGroup) {
        Object.keys(parent.controls).forEach(function (key) {
            var control = parent.controls[key];
            logFromErrors(key, control);
        });
        return;
    }
    if (parent instanceof FormArray) {
        parent.controls.forEach(function (control, index) {
            logFromErrors(index, control);
        });
        return;
    }
}
